import type {FC} from 'react';
import {routes} from '../../../../config/constants';
import {cn} from '../../../../lib/classname';
import {useBooleanState} from '../../../services/useBooleanState';
import {CommonLink} from '../../CommonLink';
import {AuthActionMenu} from './AuthActionMenu';

export const LoginRegistButton: FC = () => {
  const [shownAuthActionMenu, showAuthActionMenu, hideAuthActionMenu] =
    useBooleanState(false);
  return (
    <div
      className="relative py-4"
      onMouseEnter={showAuthActionMenu}
      onMouseLeave={hideAuthActionMenu}
    >
      <CommonLink
        className={cn(
          'text-accent-1 bg-transparent hover:bg-transparent pc:text-sm pc:bg-accent-2 pc:text-white pc:hover:bg-accent-1 pc:px-12 px-0',
          'font-bold rounded-full py-12',
        )}
        href={routes.LOGIN}
      >
        ログイン・新規登録
      </CommonLink>
      {shownAuthActionMenu && (
        <div className="absolute top-[25px] z-50 pt-12 left-[-20px]">
          <div className="overflow-hidden pc:rounded-12 bg-background-1 shadow-modal">
            <AuthActionMenu />
          </div>
        </div>
      )}
    </div>
  );
};
